import React from 'react';

export default function Modal({ children, isOpen }) {
  return (
    <div
      className={`fixed inset-0 z-50 overflow-hidden ${
        isOpen ? 'backdrop-blur-sm backdrop-brightness-[0.25] backdrop-filter backdrop-saturate-100' : 'hidden'
      }`}
    >
      <div
        className="relative
        mt-12 mx-auto p-4 
        max-w-md w-full 
        space-y-8 rounded-xl bg-[#202020] shadow-md
        "
      >
        {children}
      </div>
    </div>
  );
}
